import { OpenChatBotType } from "../reducers/reducer-chatbot";

export const CHATBOT_INJECT = "CHATBOT_INJECT" as const;
export const CHATBOT_INIT = "CHATBOT_INIT" as const;
export const CHATBOT_INJECT_SUCCESS = "CHATBOT_INJECT_SUCCESS" as const;
export const CHATBOT_INJECT_ERROR = "CHATBOT_INJECT_ERROR" as const;
export const CHATBOT_INIT_SUCCESS = "CHATBOT_INIT_SUCCESS" as const;
export const CHATBOT_INIT_ERROR = "CHATBOT_INIT_ERROR" as const;
export const ADD_LOOKUP_NAMES = "ADD_LOOKUP_NAMES" as const;
export const CHATBOT_UPDATE_ATTRIBUTES = "CHATBOT_UPDATE_ATTRIBUTES" as const;
export const CHATBOT_UPDATE_ATTRIBUTES_SUCCESS = "CHATBOT_UPDATE_ATTRIBUTES_SUCCESS" as const;
export const CHATBOT_UPDATE_ATTRIBUTES_ERROR = "CHATBOT_UPDATE_ATTRIBUTES_ERROR" as const;
export const CHATBOT_ADD_ATTRIBUTES = "CHATBOT_ADD_ATTRIBUTES" as const;
export const CHATBOT_OPEN = "CHATBOT_OPEN" as const;
export const CHATBOT_OPEN_ERROR = "CHATBOT_OPEN_ERROR" as const;
export const CHATBOT_OPEN_SUCCESS = "CHATBOT_OPEN_SUCCESS" as const;
export const CHATBOT_ADD_LOOKUP_NAMES = "CHATBOT_ADD_LOOKUP_NAMES" as const;
export const VERIFY_BENEFIT_WITH_LOOKUP_NAME = "VERIFY_BENEFIT_WITH_LOOKUP_NAME" as const;
export const CHATBOT_CLOSE_CONVERSATION = "CHATBOT_CLOSE_CONVERSATION" as const;
export const CHATBOT_LOG_INTAKE = "CHATBOT_LOG_INTAKE" as const;
export const CHATBOT_LOG_INTAKE_SUCCESS = "CHATBOT_LOG_INTAKE_SUCCESS" as const;
export const CHATBOT_LOG_INTAKE_ERROR = "CHATBOT_LOG_INTAKE_ERROR" as const;
export const CHATBOT_OPEN_FAILED_FINAL = "CHATBOT_OPEN_FAILED_FINAL" as const;

export function injectChatbot(data) {
  return { type: CHATBOT_INJECT, payload: data };
}

export function verifyBenefitsWithLookupName() {
  return { type: VERIFY_BENEFIT_WITH_LOOKUP_NAME };
}

export function injectChatbotSuccess() {
  return { type: CHATBOT_INJECT_SUCCESS };
}

export function injectChatbotError() {
  return { type: CHATBOT_INJECT_ERROR };
}

export function initChatbot() {
  return { type: CHATBOT_INIT };
}
export function initChatbotSuccess() {
  return { type: CHATBOT_INIT_SUCCESS };
}

export function initChatbotError() {
  return { type: CHATBOT_INIT_ERROR };
}

export function addAttributes(payload) {
  return { type: CHATBOT_ADD_ATTRIBUTES, payload };
}

export function updateAttributes(payload) {
  return { type: CHATBOT_UPDATE_ATTRIBUTES, payload };
}

export function updateAttributesSuccess() {
  return { type: CHATBOT_UPDATE_ATTRIBUTES_SUCCESS };
}
export function updateAttributesError() {
  return { type: CHATBOT_UPDATE_ATTRIBUTES_ERROR };
}

export function addLookupNames(payload) {
  return { type: CHATBOT_ADD_LOOKUP_NAMES, payload };
}

export function openChatbot(payload?: OpenChatBotType) {
  return { type: CHATBOT_OPEN, payload };
}

export function openChatbotError(payload: any) {
  return { type: CHATBOT_OPEN_ERROR, payload };
}

export function openChatbotSuccess() {
  return { type: CHATBOT_OPEN_SUCCESS };
}

export function closeConversation() {
  return { type: CHATBOT_CLOSE_CONVERSATION };
}

export const logChatIntakeResults = (payload: string) => ({
  type: CHATBOT_LOG_INTAKE,
  payload,
});

export const logChatIntakeSuccess = (payload) => ({
  type: CHATBOT_LOG_INTAKE_SUCCESS,
  payload,
});

export const logChatIntakeError = (payload) => ({
  type: CHATBOT_LOG_INTAKE_ERROR,
  payload,
});

export function setChatbotFailedFinal() {
  return { type: CHATBOT_OPEN_FAILED_FINAL };
}

export type ChatbotActions =
  | ReturnType<typeof injectChatbot>
  | ReturnType<typeof verifyBenefitsWithLookupName>
  | ReturnType<typeof injectChatbotSuccess>
  | ReturnType<typeof injectChatbotError>
  | ReturnType<typeof initChatbot>
  | ReturnType<typeof initChatbotSuccess>
  | ReturnType<typeof initChatbotError>
  | ReturnType<typeof addAttributes>
  | ReturnType<typeof updateAttributes>
  | ReturnType<typeof updateAttributesSuccess>
  | ReturnType<typeof updateAttributesError>
  | ReturnType<typeof addLookupNames>
  | ReturnType<typeof openChatbot>
  | ReturnType<typeof openChatbotError>
  | ReturnType<typeof openChatbotSuccess>
  | ReturnType<typeof closeConversation>
  | ReturnType<typeof logChatIntakeResults>
  | ReturnType<typeof logChatIntakeSuccess>
  | ReturnType<typeof logChatIntakeError>
  | ReturnType<typeof setChatbotFailedFinal>;
